import React, { createContext, useContext, useEffect, useState } from 'react';
const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const login = () => setIsAuthenticated(true);
  const logout = () => setIsAuthenticated(false);
  const isAuth = localStorage.getItem('accessToken');
  const checkAuth = () => {return isAuth === null ? false : true;};
  useEffect(() => {
    isAuth?setIsAuthenticated(true):setIsAuthenticated(false);
  }, []);
  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
export const useAuth = () => useContext(AuthContext);